import React, { useEffect } from 'react';
import Layout from './components/layout/app';
import { BrowserRouter } from 'react-router-dom'
import './styles/styles.css'
import Units from './components/util/units';

function App() {
  useEffect(() => {
    if (localStorage.getItem('access-token-jwt')) {
      Units.load();
    }
  }, []);

  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
